import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import DownloadIcon from '@mui/icons-material/Download';
import translate from '../../../i18n/translate';

interface Props {
  open: boolean;
  onClose: () => void;
  onDownload: (startPeriod?: string, endPeriod?: string) => void;
  title?: string;
}

const PeriodDownloadModal: React.FC<Props> = ({ open, onClose, onDownload, title }) => {
  const [start, setStart] = useState<string>('');
  const [end, setEnd]     = useState<string>('');

  const handleDownload = () => {
    onDownload(start || undefined, end || undefined);
    onClose();
  };

  const handleClose = () => {
    setStart('');
    setEnd('');
    onClose();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ color: 'warning.main', fontWeight: 'bold' }}>
          {title || translate('marketingPersonsDownloadAllExcel')}
        </DialogTitle>

        <DialogContent>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            {translate('marketingPersonsSelectPeriod')}
          </Typography>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <DatePicker
              label={translate('marketingPersonsPeriodStart')}
              value={start ? dayjs(start) : null}
              onChange={(v: Dayjs | null) => setStart(v ? v.format('YYYY-MM-DD') : '')}
              renderInput={(params) => (
                <TextField {...params} fullWidth size="small" color="warning" />
              )}
            />
            <DatePicker
              label={translate('marketingPersonsPeriodEnd')}
              value={end ? dayjs(end) : null}
              onChange={(v: Dayjs | null) => setEnd(v ? v.format('YYYY-MM-DD') : '')}
              renderInput={(params) => (
                <TextField {...params} fullWidth size="small" color="warning" />
              )}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="warning">
            {translate('marketingPersonsCancel')}
          </Button>
          <Button
            onClick={handleDownload}
            color="warning"
            variant="contained"
            startIcon={<DownloadIcon />}
          >
            {translate('marketingPersonsDownloadAllExcel')}
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default PeriodDownloadModal;
